import {GET_WEBSERVICE_USER_INFO} from "../types";

export default (id) => async (dispatch, getState) => {
  let payload = {
      selectedEntry: id === null ? {} : getState().users.entries.find(x => x.ip === id)
  };
  dispatch({type: GET_WEBSERVICE_USER_INFO, payload: payload});
};